import React from "react";
import { Link } from "react-router-dom";
import { GraduationCap, ArrowRight } from "lucide-react";

/** Reusable promo banner for the Salesforce Data Cloud Certification Program
 * (paid, internship-style, Training Partner: E-Learning IT). Used on the
 * public Landing Page (above the free 30-Day Challenge section) AND on the
 * free Data Cloud Challenge's Day 30 page (as a natural upsell once a
 * learner finishes the free capstone). */
export function CertificationProgramBanner({ testId = "certification-program-banner", className = "" }) {
  return (
    <Link
      to="/salesforce-data-cloud-internship"
      data-testid={testId}
      className={`group relative block rounded-3xl border border-amber-400/25 bg-gradient-to-br from-amber-500/10 via-black/40 to-black/60 p-8 sm:p-10 overflow-hidden hover:border-amber-400/50 transition-colors ${className}`}
    >
      <div className="absolute -top-24 -right-24 w-72 h-72 bg-amber-500/20 rounded-full blur-3xl" />
      <div className="relative flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
        <div>
          <span className="inline-flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-[0.2em] text-amber-300 bg-amber-400/10 border border-amber-400/30 rounded-full px-3 py-1">
            <GraduationCap className="w-3.5 h-3.5" /> Premium · Internship-Style Training
          </span>
          <h2 className="font-heading text-2xl sm:text-3xl font-semibold text-white mt-4">Salesforce Data Cloud Certification Program</h2>
          <p className="text-sm sm:text-base text-slate-400 mt-2 max-w-xl">
            8 weeks · Live Online + Self-Paced Recordings · 12 modules + 5 real-time business projects · mentor-led,
            certification-ready. Training Partner: E-Learning IT.
          </p>
        </div>
        <div className="flex flex-col items-start lg:items-end gap-3 shrink-0">
          <span className="text-3xl font-bold text-white">₹20,000</span>
          <span className="flex items-center gap-2 text-sm font-bold text-black bg-amber-400 group-hover:bg-amber-300 rounded-xl px-5 py-2.5 transition-colors">
            View Program <ArrowRight className="w-4 h-4" />
          </span>
        </div>
      </div>
    </Link>
  );
}
